const dict = {
  chooseLang: "Scegli la lingua",

  // Licenza
  instructions: "Istruzioni",
  step1: "Passo 1: Scansiona il codice QR",
  locateqr: "Individua il codice QR alla tua destra.",
  useSmartphone:
    "Usa la fotocamera del tuo smartphone o un'app per scannerizzare codici QR per scansionarlo. Questo ti porterà al passaggio successivo.",
  step2: "Passo 2: Inserisci le informazioni sulla playlist",
  afterScan:
    "Dopo aver scansionato il codice QR, ti verrà chiesto di inserire le informazioni della tua playlist.",
  makeSure: "Assicurati di compilare tutti i campi richiesti.",
  step3: "Passo 3: Torna all'app",
  onceYou:
    "Una volta inseriti i dettagli della tua playlist, puoi tornare all'app e continuare la tua esperienza.",
  refresh: "AGGIORNA",
  playlist: "Playlist",
  bigPlaylist: "PLAYLIST",
  noLicence: "Non hai una licenza.",
  scanLicence: "Scansiona per acquistare una licenza.",
  noPlaylist: "Non hai alcuna playlist",
  privacyBig: "MODALITÀ PRIVACY",
  scanToAddBig: "SCANSIONA PER AGGIUNGERE PLAYLIST",
  scanToBuyBig: "SCANSIONA PER ACQUISTARE LICENZA",
  orVisit: "oppure visita",
  andenterdeviceID: "e inserisci questo ID dispositivo:",
  removePlaylist: "Rimuovi Playlist",
  wantToRemove: "Vuoi rimuoverla?",
  cancelBig: "ANNULLA",

  // Home
  bigLiveTv: "TV IN DIRETTA",
  bigMovies: "FILM",
  bigSeries: "SERIE",

  // Menu Canali
  noChannels: "Questa playlist non contiene dati sui canali",
  searchChannels: "Cerca Canale",
  tapToPlay: "Tocca per riprodurre il video in streaming.",
  categoryEmpty: "Questa categoria è vuota",

  // Film
  noMovies: "Questa playlist non contiene dati sui film",
  searchMovies: "Cerca Film",

  // Serie
  noSeries: "Questa playlist non contiene dati sulle serie",
  searchSeries: "Cerca Serie",

  // Entità
  play: "RIPRODUCI",
  recommendations: "Raccomandazioni",

  // Informazioni Utente
  userInfo: "Informazioni Utente",
  aboutApp: "Informazioni sull'App",

  // Informazioni Account
  account: "Account",
  subscriptions: "Abbonamenti",
  privacyPilicy: "Privacy e Politica",
  languge: "Lingua",
  english: "Inglese",
  italian: "Italiano",
  german: "Tedesco",
  spanish: "Spagnolo",
  french: "Francese",
  greek: "Greco",

  // Ultimi dettagli
  playInfo: "Informazioni sulla Playlist",
  playName: "Nome Playlist:",
  host: "Host:",
  username: "Nome utente:",
  password: "Password:",
  packName: "Nome Pacchetto:",
  expireDate: "Data di Scadenza:",

  // Politica sulla Privacy
  one: "1. Dichiarazione di responsabilità sui contenuti: Applay è una piattaforma progettata per migliorare la tua esperienza digitale. Tuttavia, è importante notare che Applay non ospita, fornisce o distribuisce contenuti video. Il nostro servizio è strutturato per supportare il tuo percorso digitale, ma non siamo responsabili della disponibilità, qualità o contenuto del materiale video, poiché ciò esula dal nostro servizio.",
  two: "2. Nessuna responsabilità per contenuti di terze parti: Applay LLC non è responsabile per eventuali contenuti di terze parti a cui puoi accedere tramite la nostra applicazione. Il tuo coinvolgimento con qualsiasi contenuto esterno, inclusa la sua legalità, affidabilità o idoneità, è esclusivamente a tuo rischio.",
  three:
    "3. Giurisdizione e conformità: Applay LLC opera sotto la giurisdizione degli Stati Uniti. Gli utenti sono responsabili di garantire che l'uso dell'applicazione sia conforme a tutte le leggi locali, statali e federali.",
  four: "4. Politica sui prezzi: I prezzi dei servizi di Applay sono soggetti a modifiche in qualsiasi momento senza preavviso. Accettando questo accordo, riconosci e accetti che i prezzi possono variare e che tali modifiche non influenzeranno il tuo servizio attuale fino al rinnovo dell'abbonamento.",
  five: `5. Nessuna garanzia: L'applicazione Applay e i suoi servizi sono forniti "così come sono" senza alcuna garanzia esplicita o implicita, incluse, ma non limitate a, garanzie implicite di commerciabilità, idoneità per uno scopo particolare e non violazione.`,
  six: "6. Accettazione dei termini: Cliccando su Accetto, accetti di essere vincolato dai termini di questa dichiarazione di non responsabilità e riconosci che qualsiasi violazione potrebbe comportare la cessazione del tuo accesso ai servizi Applay.",
  orbixUserAgreement: "ACCORDO E DICHIARAZIONE DI RESPONSABILITÀ UTENTE Applay",
  beforeyouProcc:
    "Prima di procedere, leggi e accetta i seguenti termini e condizioni:",

  // Informativa sulla privacy di Evomedia
  evomediaTitle: "Informativa sulla Privacy di Evo TV",
  evomediaSubtitle:
    "Si prega di leggere le seguenti informazioni su come vengono gestiti i tuoi dati:",
  evomediaSection1Title: "1. Trattamento e Raccolta dei Dati Tecnici",
  evomediaSection1Body1:
    "L'applicazione evo tv è progettata esclusivamente come strumento tecnico per i clienti Evomedia ammissibili. L'applicazione non dispone di moduli di registrazione manuale, creazione di account in-app, né raccoglie dati personali diretti (come il tuo nome, numero di telefono o indirizzo email).",
  evomediaSection1Body2:
    "Tuttavia, per consentire lo streaming multimediale e garantire la sicurezza del servizio, il sistema elabora la seguente categoria di dati:",
  evomediaSection1Body3:
    "Identificatori del dispositivo: L'indirizzo MAC del dispositivo o un ID cliente interno viene trasmesso in modo sicuro (tramite SSL/HTTPS) ai nostri server con l'unico scopo di validare, autenticare e autorizzare l'accesso ai flussi multimediali in streaming collegati al tuo piano contrattuale.",
  evomediaSection1Body4:
    "Base giuridica e finalità: Il trattamento di questi identificatori è strettamente necessario per l'esecuzione di un contratto (la fornitura del servizio di streaming richiesto) e per la sicurezza e la prevenzione delle frodi (garantendo che solo i dispositivi autorizzati accedano ai flussi protetti). Questi dati tecnici non vengono mai utilizzati per scopi di marketing, non vengono mai condivisi con terze parti e non vengono utilizzati per monitorare la tua cronologia di navigazione generale.",
  evomediaSection2Title: "2. Diritti dell'Utente (GDPR)",
  evomediaSection2Body1:
    "Ai sensi del Regolamento Generale sulla Protezione dei Dati (GDPR), poiché gli identificatori tecnici sono collegati al tuo account cliente, hai il diritto di accedere, rettificare, limitare o richiedere la cancellazione dei dati associati al tuo dispositivo. Per esercitare questi diritti, contattaci all'indirizzo suporte@evomedia.pt.",
  evomediaSection3Title: "3. Privacy dei Minori",
  evomediaSection3Body1:
    "Non commercializziamo direttamente i nostri servizi ai minori, né raccogliamo consapevolmente dati da minori di 13 anni. L'accesso all'app è gestito e autorizzato dal titolare dell'account (il cliente adulto).",
  evomediaSection4Title: "4. Modifiche a questa Informativa",
  evomediaSection4Body1:
    "Potremmo aggiornare periodicamente la nostra Informativa sulla Privacy per riflettere aggiornamenti tecnici o cambiamenti normativi. Eventuali aggiornamenti diventeranno effettivi immediatamente dopo la pubblicazione su questa pagina.",
  evomediaSection5Title: "5. Contattaci",
  evomediaSection5Body1:
    "Se hai domande riguardo alla tua privacy o alla gestione tecnica dell'applicazione, contattaci tramite:",
  evomediaSection5Body2: "Email di supporto ufficiale: suporte@evomedia.pt",
  evomediaSection5Body3:
    "Email dell'account sviluppatore: evomediamobile@gmail.com",

  //additional
  exitApp: "Esci da Applay",
  wantToExit: "Sei sicuro di voler uscire da Applay?",
  Resume: "Riprendi",

  whatsnewinv: "Cosa c'è di nuovo nella v",
  whatsnew: "Cosa c'è di nuovo",
  instanthomescreen: "Navigazione Migliorata del Menu Canali",
  instanthomescreendesc:
    "Flusso di navigazione migliorato ed esperienza utente nella selezione dei canali.",
  turbomoviesearch: "Informazioni Complete delle Impostazioni",
  turbomoviesearchdesc:
    "Impostazioni più dettagliate e opzioni di configurazione raccolte in un unico posto.",
  lighterondataandbattery: "Funzione di Ripresa Intelligente",
  lighterondataandbatterydesc:
    "Salva e ripristina automaticamente la tua posizione di riproduzione senza interruzioni.",
  underthehoodfixes: "Correzioni Interne",
  underthehoodfixesdesc:
    "Maggiore stabilità del lettore e affidabilità delle operazioni di ricerca.",
};

export default dict;
